<template>
  <div class="content">
    <IllustrationIntroSection />
    <IllustrationStyleSection />
    <IllustrationColorsSection />
    <IllustrationPureColorsceneSection />
    <IllustrationCodesSection />    
    <IllustrationGradientsSection />    
    <IllustrationFrameworksSection />    
    <IllustrationsSection />
    <illustrationGoodPraticesSection />      
    <IllustrationSummarySection />
    <IllustrationPhotosSection />
  </div>
</template>

<script lang="ts">
import IllustrationIntroSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationIntroSection.vue'
import IllustrationsSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationsSection.vue'
import illustrationGoodPraticesSection from '@/components/VisualIdentityPage/sections/illustration/illustrationGoodPraticesSection.vue'
import IllustrationStyleSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationStyleSection.vue'
import IllustrationColorsSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationColorsSection.vue'
import IllustrationGradientsSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationGradientsSection.vue'
import IllustrationPureColorsceneSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationPureColorsceneSection.vue'
import IllustrationCodesSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationCodesSection.vue'
import IllustrationFrameworksSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationFrameworksSection.vue'
import IllustrationSummarySection from '@/components/VisualIdentityPage/sections/illustration/IllustrationSummarySection.vue'
import IllustrationPhotosSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationPhotosSection.vue'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    IllustrationIntroSection,
    IllustrationsSection,
    illustrationGoodPraticesSection,
    IllustrationStyleSection,
    IllustrationColorsSection,
    IllustrationGradientsSection,    
    IllustrationPureColorsceneSection,
    IllustrationCodesSection,
    IllustrationFrameworksSection,
    IllustrationSummarySection,
    IllustrationPhotosSection
  }
})
export default class IllustrationView extends Vue {}
</script>

<style lang="scss"></style>
